import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Quiz from './quiz/Quiz';
import CartaoConfirmPage from './CartaoConfirmPage';
import LoginCPFPage from './LoginCPFPage';
import ViewPDF from './ViewPDF';
import MetaPixel from './components/MetaPixel';

const App = () => {
	return (
		<Router>
			<MetaPixel />
			<Routes>
				<Route path="/" element={<Quiz />} />
				<Route path="/onboarding/customer/card" element={<CartaoConfirmPage />} />
				<Route path="/onboarding/customer/cpf" element={<LoginCPFPage />} />
				<Route path="/onboarding/customer/accept-terms" element={<ViewPDF />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</Router>
	);
};

export default App;
